// T270(6) — a sortable table header.
// T142 — sortable table header. Clicking sorts by this column (toggling the
// direction when it's already active). Shows ▲/▼ on the active column, ↕ otherwise.
export default function SortTh({ label, colKey, sortKey, sortDir, onSort, className = '' }) {
  const active = sortKey === colKey;
  return (
    <th
      className={`px-3 py-2 font-medium ${className}`}
      aria-sort={active ? (sortDir === 'asc' ? 'ascending' : 'descending') : 'none'}
    >
      <button
        type="button"
        onClick={() => onSort(colKey)}
        title={`Sort by ${label}`}
        className={
          'inline-flex items-center gap-1 uppercase tracking-wide transition hover:text-slate-200 ' +
          (active ? 'text-brand-400' : 'text-slate-500')
        }
      >
        <span>{label}</span>
        <span aria-hidden="true" className="text-[9px]">{active ? (sortDir === 'asc' ? '▲' : '▼') : '↕'}</span>
      </button>
    </th>
  );
}
